var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationProvider", {
        attrs: { rules: _vm.criteriaValueValidations, slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors, classes }) {
              return [
                !_vm.isGeoTag &&
                !_vm.allowBulkTagsUpload &&
                !_vm.showPrepopulatedValues
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.criteriaValue,
                          expression: "criteriaValue"
                        }
                      ],
                      staticClass: "form-control filter-criteria-value",
                      class: classes,
                      attrs: {
                        placeholder: _vm.$t("ROUTER_VALUE_PH"),
                        type: "text"
                      },
                      domProps: { value: _vm.criteriaValue },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.criteriaValue = $event.target.value
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ValidationProvider",
        { attrs: { rules: "required", slim: "" } },
        [
          _vm.isGeoTag && !_vm.showPrepopulatedValues
            ? _c("MultiSelect", {
                staticClass: "filter-or-criteria__value",
                class: { "multi-select-lg": _vm.isFullWidth },
                attrs: {
                  "list-items": _vm.uSStates,
                  "value-property": _vm.stateValueProperty,
                  "display-property": "displayName",
                  "search-placeholder": _vm.$t("ROUTER_TAG_SEARCH_STATES_PH"),
                  "selected-placeholder": _vm.$t("ROUTER_TAG_SELECT_STATES_PH"),
                  "show-select-all": ""
                },
                model: {
                  value: _vm.criteriaValue,
                  callback: function($$v) {
                    _vm.criteriaValue = $$v
                  },
                  expression: "criteriaValue"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ValidationProvider",
        { attrs: { rules: "required", slim: "" } },
        [
          _vm.showPrepopulatedValues && !_vm.allowBulkTagsUpload
            ? [
                _vm.showLoader
                  ? _c(
                      "div",
                      [
                        _c("Loader", { attrs: { "custom-class": "size-sm" } }),
                        _vm._v(
                          "\n\n        " +
                            _vm._s(_vm.prepopulatedValuesOptions.loadingText) +
                            "\n      "
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showLoader
                  ? _c("SearchableDropdown", {
                      attrs: {
                        config: _vm.prepopulatedDropdownOptions,
                        placeholder:
                          _vm.prepopulatedValuesOptions.inputPlaceholder,
                        rules: "required",
                        required: ""
                      },
                      model: {
                        value: _vm.criteriaValue,
                        callback: function($$v) {
                          _vm.criteriaValue = $$v
                        },
                        expression: "criteriaValue"
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.allowBulkTagsUpload
        ? _c("BulkTagUploader", {
            staticClass: "filter-or-criteria__value",
            attrs: { "bulk-tag-list": _vm.bulkTagsUploads },
            model: {
              value: _vm.criteriaValue,
              callback: function($$v) {
                _vm.criteriaValue = $$v
              },
              expression: "criteriaValue"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }